export type CardBrand = 'Visa' | 'Mastercard' | 'AMEX' | 'Discover' | null;

const CARD_LENGTHS: Record<Exclude<CardBrand, null>, number[]> = {
  Visa: [16],
  Mastercard: [16],
  AMEX: [15],
  Discover: [16],
};

export function normalizeCardNumber(value: string): string {
  return value.replace(/\s|-/g, '');
}

export function detectCardBrand(value: string): CardBrand {
  const cardNumber = normalizeCardNumber(value);

  if (/^4/.test(cardNumber)) {
    return 'Visa';
  }

  if (
    /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(
      cardNumber
    )
  ) {
    return 'Mastercard';
  }

  if (/^3[47][0-9]{13}$/.test(cardNumber)) {
    return 'AMEX';
  }

  if (
    /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5])|64[4-9]|65)/.test(cardNumber)
  ) {
    return 'Discover';
  }

  return null;
}

export function isLuhnValid(value: string): boolean {
  const cardNumber = normalizeCardNumber(value);

  if (!/^\d+$/.test(cardNumber)) {
    return false;
  }

  let sum = 0;
  let shouldDouble = false;

  for (let i = cardNumber.length - 1; i >= 0; i -= 1) {
    let digit = Number(cardNumber.charAt(i));

    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) {
        digit -= 9;
      }
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return sum % 10 === 0;
}

export function isSupportedLength(value: string, brand: CardBrand): boolean {
  if (!brand) {
    return false;
  }

  return CARD_LENGTHS[brand].includes(normalizeCardNumber(value).length);
}

export function isValidCardNumber(value: string): boolean {
  const brand = detectCardBrand(value);
  return isSupportedLength(value, brand) && isLuhnValid(value);
}
